const SQLITE_HEADER = new Uint8Array([
  0x53, 0x51, 0x4c, 0x69, 0x74, 0x65, 0x20, 0x66,
  0x6f, 0x72, 0x6d, 0x61, 0x74, 0x20, 0x33, 0x00,
]);

export const isSqliteDatabase = (data: Uint8Array): boolean =>
  SQLITE_HEADER.every((byte, index) => data[index] === byte);

export const decodeDatabaseFile = (data: Uint8Array): Uint8Array => {
  if (isSqliteDatabase(data)) {
    return data;
  }

  throw new Error("The selected file is not a standard SQLite database.");
};
